<template>
  <div>
    <div class="uploader ready">
      <div
        class="upload-drop-site upload-icon"
      >
        <div
          class="handler"
          tabindex="0"
          @click="$refs.cameraFileInput.click()"
        >
          <input
            ref="cameraFileInput"
            accept="image/png,image/jpeg,image/jpg"
            type="file"
            capture="camera"
            autocomplete="off"
            tabindex="-1"
            style="display: none"
            multiple
            :name="name"
            @input="cameraFileInputFun"
          />

        </div>
      </div>
    </div>
  </div>
  </template>
  <script>
  import {
    checkImageOrFail
  } from '@/utils/validation/image'
  // import VPhotoPreview from './VPhotoPreview'
  // import {
  //   createMixin as createCarApiMixin,
  //   carActionTypes,
  //   carGetterTypes,
  // } from '@/mixins/carsApiMixin'
  
  export default {
    name: 'VCameraInput',
  
    // mixins: [createCarApiMixin()],
  
    components: {
      // VPhotoPreview
    },
  
    props: {
      name: {
        type: String,
        default: ''
      },
      minCount: {
        type: Number,
        default: 1
      },
      errorMsg: {
        type: String
      },
      onInputFiles: {
        type: Function
      }
      // maxCount: {
      //   type: Number,
      // }
    },
  
    data: () => ({
      isActiveDragEvent: false,
      photos: [],
      errorList: [],
      allFilesCount: 1,
      morePhotos: 0,
      showError: false,
      // errorMsg: '',
    }),
  
    methods: {
      cameraFileInputFun(e){
        this.onInputFiles(e)
        this.$refs.cameraFileInput.value = null;
      },
      hasErrors() {
        this.showError = this.photos.length < this.minCount
        if (this.photos.length < this.minCount) {
          this.showError = true
        } 
        // else if (this.maxCount && this.photos.length > this.maxCount)
        //   this.showError = this.photos.length > this.maxCount
  
        if (this.showError) {
          this.morePhotos = this.minCount - this.photos.length
          this.$nextTick(() => {
            this.$refs.errorText.focus()
          })
        }
  
        return this.showError
      },
  
    }
  }
  </script>
  <style>
  .photo-input__remove-btn {
    z-index: 3;
  }
  
  .photo-input__remove-btn_deleting::after {
      margin-top: 0 !important;
      background: none !important;
      width: calc(100% - 4px) !important;
      height: calc(100% - 4px) !important;
      border: solid;
      border-radius: 50em;
      border-right: .25em solid white;
      animation: spinner-border .75s linear infinite;
  }
  .upload-drop-site.upload-icon{
    height: 32px !important;
    width: 32px !important;
    background: transparent !important;
    border-radius: 0 !important;
    border: 0 !important;
  }
  </style>
  